import React from 'react';
import './index.scss';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

export const RELATED_ITEM_SLUG_KEY = {
  SEO_NAME: 'seoName',
  SLUG: 'slug',
  COUPONS: 'coupons'
};
export const RELATED_ITEM_SLUG_PREFIX = {
  PRESCRIPTION_PAGE: '/prescription',
  DRUG_CLASSES_PAGE: '/drug-classes',
  CONDITIONS_PAGE: '/conditions',
  COLLECTIONS_PAGE: '/resources'
};

export const RelatedItem = ({ slug, title, slugPrefix, lang }) => {
  return (
    <li>
      <a href={`${_.withLocale(lang, slugPrefix)}/${slug}`}>{title}</a>
      <span className="rightArrow"></span>
    </li>
  );
};

export const RelatedItemList = ({
  relatedData,
  slugPrefix,
  isLimited,
  slugType,
  lang
}) => {
  const limitedData = isLimited ? relatedData.slice(0, 8) : relatedData;
  return (
    <ul>
      {limitedData.map((item, index) => (
        <RelatedItem
          key={index}
          title={item?.name || item?.title || item?.drugName}
          slug={
            slugType !== RELATED_ITEM_SLUG_KEY.COUPONS
              ? item?.[slugType]
              : `${item?.seoName}/${item?.seoName}-${slugType}`
          }
          slugPrefix={slugPrefix}
          lang={lang}
        />
      ))}
    </ul>
  );
};

const RelatedList = ({
  heading,
  slugPrefix,
  slugType = RELATED_ITEM_SLUG_KEY.SEO_NAME,
  relatedData,
  isLimited = false,
  id,
  i18n
}) => {
  if (!relatedData || relatedData.length === 0) {
    return null;
  }
  return (
    <section id={id} className="relatedList">
      <article>
        <h2 className="relatedListHeading">{heading}</h2>
        <RelatedItemList
          relatedData={relatedData}
          slugPrefix={slugPrefix}
          isLimited={isLimited}
          slugType={slugType}
          lang={i18n.language}
        />
      </article>
    </section>
  );
};

export default React.memo(withTranslation()(RelatedList));
